// Copyright (c) 2021 Proto Labs, Inc. All Rights Reserved.

export const HTTPMethods = Object.freeze({
	Put: 'PUT',
	Get: 'GET',
	Post: 'POST',
	Delete: 'DELETE',
});

export default {
	HTTPMethods,
};
